export default __webpack_public_path__ + "static/media/ctWizardComplete.c9d5ee02.png";